import React, { useState } from 'react';

import { SurveyCreator } from "survey-creator-react";
import { localization } from "survey-creator-core";
import { Serializer, SvgRegistry, slk } from "survey-core";

import SurveyAPI from "../../../api/api_calls/SurveyAPI";


function CreateSurveyCreator(surveyJson, saveNo, saveSurveyCallback, isScreener, missionId) {

    // const tempSurveyJSON = {
    //     "title": "NPS Survey Question",
    //     "completedHtml": "<h3>Thank you for your feedback</h3>",
    //     "completedHtmlOnCondition": [
    //         {
    //             "expression": "{nps_score} >= 9",
    //             "html": "<h3>Thank you for your feedback</h3> <h4>We are glad that you love our product. Your ideas and suggestions will help us make it even better.</h4>"
    //         },
    //         {
    //             "expression": "{nps_score} >= 6  and {nps_score} <= 8",
    //             "html": "<h3>Thank you for your feedback</h3> <h4>We are glad that you shared your ideas with us. They will help us make our product better.</h4>"
    //         }
    //     ],
    //     "pages": [
    //         {
    //             "name": "page1",
    //             "elements": [
    //                 {
    //                     "type": "rating",
    //                     "name": "nps_score",
    //                     "title": "On a scale of zero to ten, how likely are you to recommend our product to a friend or colleague?",
    //                     "isRequired": true,
    //                     "rateCount": 11,
    //                     "rateMin": 0,
    //                     "rateMax": 10,
    //                     "minRateDescription": "(Most unlikely)",
    //                     "maxRateDescription": "(Most likely)"
    //                 },
    //                 {
    //                     "type": "checkbox",
    //                     "name": "promoter_features",
    //                     "visibleIf": "{nps_score} >= 9",
    //                     "title": "Which of the following features do you value the most?",
    //                     "description": "Please select no more than three features.",
    //                     "isRequired": true,
    //                     "validators": [
    //                         {
    //                             "type": "answercount",
    //                             "text": "Please select no more than three features.",
    //                             "maxCount": 3
    //                         }
    //                     ],
    //                     "choices": [
    //                         "Performance",
    //                         "Stability",
    //                         "User interface",
    //                         "Complete functionality",
    //                         "Learning materials (documentation, demos, code examples)",
    //                         "Quality support"
    //                     ],
    //                     "showOtherItem": true,
    //                     "otherText": "Other features:",
    //                     "colCount": 2
    //                 },
    //                 {
    //                     "type": "comment",
    //                     "name": "passive_experience",
    //                     "visibleIf": "{nps_score} >= 7  and {nps_score} <= 8",
    //                     "title": "What can we do to make your experience more satisfying?"
    //                 },
    //                 {
    //                     "type": "comment",
    //                     "name": "disappointing_experience",
    //                     "visibleIf": "{nps_score} <= 6",
    //                     "title": "Please let us know why you had such a disappointing experience with our product"
    //                 }
    //             ]
    //         }
    //     ],
    //     "showQuestionNumbers": "off"
    // }

    const creatorOptions = {
        showLogicTab: true,
        showJSONEditorTab: false,
        showSurveyTitle: false,
        showTitlesInExpressions: true,
        allowChangeThemeInPreview: false,
        showThemeTab: false,
        isAutoSave: true,
        questionTypes: ["text", "comment", "checkbox", "radiogroup", "matrix", "image"],
        // inplaceEditForValues: true, // NEW. Also edit the line below     Serializer.findProperty("itemvalue", "text").visible = false;
        // To add - dropdown to list

    };
    const creator = new SurveyCreator(creatorOptions);
    const propertyStopList = [
        "readOnly", "showCommentArea", "commentText", "commentPlaceholder",
        "choiceValuesFromQuestion", "separateSpecialChoices",
        "choicesByUrl", "url", "path", "valueName", "titleName", "imageLinkName", "allowEmptyResponse",
        "enableIf", "bindings", "defaultValueExpression", "resetValueIf", "setValueIf", "setValueExpression", "hideIfChoicesEmpty", "choicesVisibleIf", "choicesEnableIf",
        "startWithNewLine", "hideNumber", "state", "titleLocation", "descriptionLocation", "errorLocation", "indent", "width", "minWidth", "maxWidth", "colCount", "valueName", "defaultValue", "useDisplayValuesInDynamicTexts", "clearIfInvisible",
        "requiredErrorText", "validators", "otherErrorText",
        "valuePropertyName", // This is new - trying to remove the data section from checkboxes.
        "correctAnswer", // This is the official way, we do it another way.
        // New ones for text fields
        "textUpdateMode", "maskType", "maskSettings",
        // New ones for matrices
        "columnMinWidth", "rowTitleWidth", "showHeader", "verticalAlign", "alternateRows",
        "columnsVisibleIf", "rowsVisibleIf",
        // New ones for images
        "imageLink", "contentMode", "imageHeight",
    ];

    // It messed it up when tried.
    function addPropertyShortcut(questionType, name, displayName) {
        Serializer.addProperty(questionType, {
            name: name,
            type: "multiplevalues",
            displayName: displayName,
            category: "Screening Logic",
            categoryIndex: 15,
            choices: function (obj, choicesCallback) {
                // Map obj.choices to .locTextValue.renderedText
                // return within choicesCallback
                const choices = obj.choices.map((choice) => {
                    return {
                        value: choice.value,
                        text: choice.locTextValue.renderedText
                    }
                });

                choicesCallback(choices);
            }
        });
    }

    // SvgRegistry.registerIconFromSvg("settings", '<svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M841.638649 555.271526c1.775436-14.201443 3.106758-28.625968 3.106758-43.271526 0-14.645558-1.331321-29.069059-3.106758-43.271526l93.865831-73.449849c8.432043-6.656607 10.873652-18.639522 5.325285-28.40391l-88.76158-153.779386c-5.547343-9.54233-17.087167-13.536294-27.072589-9.54233l-110.508883 44.602847c-22.856567-17.530258-47.931662-32.397874-75.003228-43.715641L622.841457 86.830601c-1.997494-10.429537-11.095709-18.639522-22.190395-18.639522l-177.523159 0c-11.095709 0-20.192901 8.209986-21.968337 18.639522l-16.643052 117.609605c-27.072589 11.316743-52.147684 25.962302-75.003228 43.715641l-110.50786-44.602847c-9.985422-3.771907-21.524223 0-27.072589 9.54233l-88.76158 153.779386c-5.547343 9.54233-3.106758 21.524223 5.325285 28.40391l93.643774 73.449849c-1.775436 14.201443-3.106758 28.625968-3.106758 43.271526 0 14.645558 1.331321 29.069059 3.106758 43.271526l-93.643774 73.449849c-8.432043 6.656607-10.873652 18.639522-5.325285 28.40391l88.76158 153.779386c5.547343 9.54233 17.086144 13.536294 27.072589 9.54233l110.508883-44.602847c22.856567 17.530258 47.931662 32.397874 75.003228 43.715641l16.643052 117.609605c1.775436 10.429537 10.873652 18.639522 21.968337 18.639522l177.523159 0c11.095709 0 20.192901-8.209986 21.968337-18.639522l16.643052-117.609605c27.072589-11.316743 52.147684-25.962302 75.003228-43.715641l110.50786 44.602847c9.985422 3.771907 21.525246 0 27.072589-9.54233l88.76158-153.779386c5.547343-9.54233 3.106758-21.524223-5.325285-28.40391L841.638649 555.271526zM511.88846 667.332764c-85.876879 0-155.332764-69.455885-155.332764-155.332764s69.455885-155.332764 155.332764-155.332764c85.876879 0 155.332764 69.455885 155.332764 155.332764S597.765339 667.332764 511.88846 667.332764z" /></svg>');



    // Manual way of adding the properties.
    // Serializer.addProperty("radiogroup", {
    //   name: "correctAnswers",
    //   type: "multiplevalues",
    //   displayName: "Correct Answer(s)",
    //   category: "Screening Logic",
    //   categoryIndex: 15,

    //   choices: function (obj, choicesCallback) {
    //     choicesCallback(obj.choices);
    //   }
    // });

    // Serializer.addProperty("radiogroup", {
    //   name: "incorrectAnswer",
    //   type: "multiplevalues",
    //   displayName: "Incorrect Answer(s)",
    //   category: "Screening Logic",
    //   categoryIndex: 15,
    //   choices: function (obj) {
    //     return obj.choices;
    //   },

    // });
    // Serializer.removeProperty("Question", "correctAnswer");
    // Serializer.addProperty("checkbox", {
    //   name: "correctAnswers",
    //   type: "multiplevalues",
    //   displayName: "Correct Answer(s)",
    //   category: "Screening Logic",
    //   categoryIndex: 15,
    //   choices: function (obj) {
    //     return obj.choices;
    //   },
    // });

    // Serializer.addProperty("checkbox", {
    //     name: "incorrectAnswer",
    //     type: "multiplevalues",
    //     displayName: "Incorrect Answer(s)",
    //     category: "Screening Logic",
    //     categoryIndex: 15,
    //     choices: function (obj) {
    //         return obj.choices;
    //     },

    // });


    creator.saveSurveyFunc = async (saveNo, callback) => {
        // window.localStorage.setItem("survey-json", creator.text);
        // callback(saveNo, true);

        saveSurveyCallback(
            creator.JSON,
            saveNo,
            callback
        );
    };

    // Create defaults for each new question added in the survey.
    creator.onQuestionAdded.add((sender, options) => {
        options.question.isRequired = true;
    });

    // Upload file to S3
    creator.onUploadFile.add(async (_sender, options) => {
        try {
            const file = options.files?.[0];
            if (!file) throw new Error("No file selected");

            // 1) Ask Rails for presigned URL + final public URL
            const signRes = await SurveyAPI.signAsset({
                missionId: missionId,
                is_screener: isScreener,
                filename: file.name,
                content_type: file.type,
                size: file.size
            });

            const uploadUrl = signRes.uploadUrl;
            const publicUrl = signRes.publicUrl;

            // 2) PUT directly to S3 (content-type MUST match what you signed)
            const putRes = await fetch(uploadUrl, {
                method: "PUT",
                headers: { "Content-Type": file.type },
                body: file
            });
            if (!putRes.ok) throw new Error("Upload failed");

            // 3) Hand URL back to Creator; it writes this into the survey JSON
            options.callback("success", publicUrl);
        } catch (e) {
            console.error(e);
            options.callback("error");
        }
    });

    // For the pane in which the questions are added.
    // Details: https://surveyjs.io/survey-creator/documentation/customize-survey-creation-process


    // Add in the screener stuff.
    Serializer.removeProperty("radiogroup", "correctAnswer");
    // Remove the value property. Also edit hte inplaceEditForValues = true above
    // Serializer.findProperty("itemvalue", "text").visible = false;

    // Add in the new correct answer properties if it's a screener.
    if (isScreener) {
        addPropertyShortcut("radiogroup", "correctAnswers", "Correct Answer(s)");
        addPropertyShortcut("checkbox", "correctAnswers", "Correct Answer(s)");
        addPropertyShortcut("radiogroup", "incorrectAnswers", "Incorrect Answer(s)");
        addPropertyShortcut("checkbox", "incorrectAnswers", "Incorrect Answer(s)");

        const translations = localization.getLocale("");
        translations.pehelp.correctAnswers = "Choosing any of these answers will let a respondent pass the screener. Refresh answers shown by clicking a different question and coming back. You don't need both correct and incorrect answers.";
        translations.pehelp.incorrectAnswers = "Choosing any of these answers will make a respondent fail the screener, Refresh answers shown by clicking a different question and coming back. You don't need both correct and incorrect answers.";
    }

    creator.onShowingProperty.add(function (sender, options) {
        if (options.obj.getType() == "survey") {
            options.canShow = false;
        } else {
            options.canShow = propertyStopList.indexOf(options.property.name) == -1;
        }
    });

    // Hide the property for Selectall, this affects botht eh question pane and the settings panel.
    Serializer.findProperty("checkbox", "showSelectAllItem").visible = false;

    slk("MjlkNjhlZjctMzNhNC00NTBiLTkyNjQtNjAwNWVhZjVkZmVlOzE9MjAyNS0wNC0wMQ==");
    creator.survey.title = "Screener Survey";
    creator.saveNo = saveNo || 0;
    // A delay between changing survey settings and saving the survey JSON schema, measured in milliseconds. 
    // Applies only when the isAutoSave property is true.
    // Default value: 500 (inherited from settings.autoSave.delay)
    creator.autoSaveDelay = 500;
    creator.isAutoSave = true;
    creator.text = JSON.stringify(surveyJson);
    if (!creator.survey.showQuestionNumbers) {
        creator.survey.showQuestionNumbers = "off";
    }

    return creator
}

export default CreateSurveyCreator;
